import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {getSiteEnvVarValue} from '../../../utils/site-config'

export const getDeliveryOptionsFallback = (siteId) => {
    const deliveryOptions = {}
    try {
        const value = getSiteEnvVarValue(getConfig()?.app, 'DELIVERY_OPTIONS_DEFAULTS', siteId)
        const defaults = typeof value === 'string' ? JSON.parse(value) : value
        const methods = siteId === 'DynamiteGarageUS' ? ['standard', 'express', 'priority'] : ['standard', 'express']
        methods.forEach((method) => {
            const range = defaults?.[method]
            if (range?.low != null && range?.high != null) {
                deliveryOptions[method] = {low: range.low, high: range.high, cost: range.cost}
            }
        })
    } catch (error) {
    }
    return {success: true, isFallback: true, deliveryOptions}
}
